import React, { useState, useMemo, useEffect } from "react";
import GpiScreen from "./GpiScreen";
import GpiProductId from "./GpiProductId";

const externalScreenMapping = {
  RCGPI039: {gpiScreenTitle : "Select/Add by GPI ID/GPI Name" , gpiScreenNumber: "RCGPI039", productTitle : "Products by ID/Label Name" , productScreenNumber: "RCPID017", },
  RCGPI036: {gpiScreenTitle : "Select/Add interacting GPI by GPI ID/GPI Name" , gpiScreenNumber: "RCGPI036", productTitle : "Products by ID/Label Name" , productScreenNumber: "RCPID017", },
  RCGPI031: {gpiScreenTitle : "Select/Add by GPI ID/GPI Name" , gpiScreenNumber: "RCGPI031", productTitle : "Select/Add GPI by Active Products by ID/Label Name" , productScreenNumber: "RCPID030", },
  RCGPI900: {gpiScreenTitle : "GPI by GPI Name/GPI ID" , gpiScreenNumber: "RCGPI900", productTitle : "GPI by Product Label Name/Product ID" , productScreenNumber: "RCPID021", },
  RCGPI043: {gpiScreenTitle : "Select/Add by GPI Name/GPI ID" , gpiScreenNumber: "RCGPI043", productTitle : "Active Products by Label Name/Product ID" , productScreenNumber: "RCPID015", },
  RCGPI902: {
    gpiScreenTitle: "GPI by GPI Name/GPI ID",
    gpiScreenNumber: "RCGPI902",
    productTitle: "GPI by Product Label Name/Product ID",
    productScreenNumber: "RCPID021",
  },
};

const GPILookup = ({
  hideModal,
  fieldMapping,
  selectMode: initialSelectMode,
  lookupType: initialLookupType,
  onSelect,
  paramsData: initialParamsData,
}) => {
  const [screen_title, setScreenTitle] = useState("GPI by GPI ID/GPI Name");
  const [screenNumber, setScreenNumber] = useState("RCGPI031");
  const [productTitle, setProductTitle] = useState("GPI by Product ID/Label Name");
  const [productScreenNumber, setProductScreenNumber] = useState("RCPID030");
  const [screenType, setScreenType] = useState("gpiName");
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(fieldMapping?.[screenType]);
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [paramsData, setParamsData] = useState(initialParamsData);
  const [multiSelect, setMultiSelect] = useState(false);

  const customHideModel = () => {
    if (lookupType === "external") {
      const message = {
        type: "hideModal",
      };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      console.log("external data", paramData, selectMode);
      setLookupType("external");
       setSelectParams(paramData.params);
       setParamsData(paramData.paramsData);
      setSelectMode(selectMode);
      setMultiSelect(paramData.multiSelect ?? false);
      if (paramData.screenNumber) {
          setScreenNumber(externalScreenMapping[paramData.screenNumber]?.gpiScreenNumber);
          setScreenTitle(externalScreenMapping[paramData.screenNumber]?.gpiScreenTitle);
          setProductScreenNumber(externalScreenMapping[paramData.screenNumber]?.productScreenNumber);
          setProductTitle(externalScreenMapping[paramData.screenNumber]?.productTitle);
        }
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  return (
    <>
      {screenType === "gpiName" ? (
        <GpiScreen
          setScreenType={setScreenType}
          selectParams={selectParams}
          hideModal={customHideModel}
          selectMode={selectMode}
          lookupType={lookupType}
          onSelect={onSelect}
          selectParamsData={paramsData}
          screenTitle = {screen_title}
          screenNumber = {screenNumber}
          multiSelect = {multiSelect}
        />
      ) : (
        <GpiProductId
          setScreenType={setScreenType}
          selectParams={selectParams}
          hideModal={customHideModel}
          selectMode={selectMode}
          lookupType={lookupType}
          onSelect={onSelect}
          productScreenTitle = {productTitle}
          productScreenNumber = {productScreenNumber}
          multiSelect = {multiSelect}
        />
      )}
    </>
  );
};
export default GPILookup;
